<template>
  <div class="allocation-details">
    <rCenterHeader :list="headerMenu">
      <div slot="search">
        <form>
          <!-- <Input
            size="large"
            v-model="params.keyWord"
            icon="ios-search"
            :placeholder="$t('fabricLibrary.search')"
            style="width: 380px; color: #081938"
            @on-search="search"
            search
          /> -->
        <Button @click="filterClick" class="filter" size="large" type="primary">
          <span class="iconfont iconshaixuan"></span>
          {{ $t("fabricLibrary.filter") }}
        </Button>
        </form>
      </div>
    </rCenterHeader>
    <div class="list">
      <Table
        width="1320"
        style="margin: 0 auto"
        :columns="columns"
        :data="data"
        :no-data-text="$t('noDate')"
      ></Table>
      <div class="common-flex common-justify-center" style="margin-top: 20px">
        <Page
          :total="total"
          @on-change="changePage"
          :page-size="params.pageSize"
        />
      </div>
    </div>
    <!-- 搜索项 -->
    <rSubaccountFilter
      :params="params"
      @search="search"
      @close="closeFilte"
      :filteShow="filteShow"
    ></rSubaccountFilter>
  </div>
</template>

<script>
import rSubaccountFilter from "../../components/r-subaccount-filter";
import rCenterHeader from "../../components/r-center-header";
import { mapActions } from "vuex";
export default {
  name: "allocation-details",
  data() {
    return {
      value: "",
      filteShow: false,
      // 头部面包屑
      headerMenu: [
        {
          name: this.$t("customer.crumbs.individualAccount"),
          to: "./user",
        },
        {
          name: this.$t("customer.crumbs.subAccount"),
          to: "./subAccount",
        },
        {
          name: this.$t("customer.crumbs.allocationDetails"),
        },
      ],
      params: {
        pageNum: 1,
        pageSize: 20,
        memberId: "",
        dealItem: "",
        dealStart: "",
        dealEnd: "",
        keyWord: "",
      },
      total: 0,
      columns: [
        {
          title: "No.",
          key: "sort",
        },
        {
          title: "Date",
          key: "dealDate",
        },
        {
          title: "Sub account",
          key: "username",
        },
        {
          title: "Transaction type",
          key: "type",
          //   <Icon type="ios-information-circle" />
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                },
              },
              [
                h("div", {
                  style: {
                    width: "5px",
                    height: "5px",
                    borderRadius: "50%",
                    marginRight: "8px",
                    background:
                      params.row.type == "Recharge"
                        ? "#0C750E"
                        : params.row.type == "Take back"
                        ? "#F5222D"
                        : "#0A4DCC",
                  },

                  on: {
                    click: () => {},
                  },
                }),
                h("div", [
                  h(
                    "div",
                    {
                      style: {
                        color: "#081938",
                      },

                      on: {
                        click: () => {},
                      },
                    },
                    params.row.type
                  ),
                ]),
              ]
            );
          },
        },
        {
          title: "Price",
          key: "address",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                },
              },
              [
                h(
                  "div",
                  {
                    style: {
                      color:
                        params.row.price.split("")[0] == "+"
                          ? "#0C750E"
                          : "#F5222D",
                    },

                    on: {
                      click: () => {
                        console.log("params", params);
                      },
                    },
                  },
                  params.row.price
                ),
              ]
            );
          },
        },
        {
          title: "Usable amount",
          key: "balance",
        },
      ],
      data: [],
    };
  },
  components: {
    rCenterHeader,
    rSubaccountFilter,
  },
  mounted() {
    this.allocationDetails();
  },
  methods: {
    ...mapActions([
      "allocationDetailsAction", //余额分配明细
    ]),
    // 搜索
    search(e) {
      this.filteShow = false;
      this.params.pageNum = 1;
      for (let key in e) {
        this.search[key] = e[key];
      }
      this.allocationDetails();
    },
    // 修改页码
    changePage(e) {
      this.params.pageNum = e;
      this.allocationDetails();
    },
    // 搜索列表
    allocationDetails() {
      this.allocationDetailsAction(this.params).then((res) => {
        res.data.map((item, index) => {
          item.sort =
            index + 1 + (this.params.pageNum - 1) * this.params.pageSize;
        });
        this.data = res.data;
        this.total = res.total;
      });
    },
    // 显示搜搜分类
    filterClick() {
      this.filteShow = true;
    },
    // 关闭搜索分类
    closeFilte() {
      this.filteShow = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.allocation-details {
  .filter {
    background: #f8f8f8;
    border: none;
    color: #081938;
    margin-left: 5px;
    width: 85px;
    font-size: 14px;
  }
  .list {
    width: 1420px;
    min-height: 100vh;
    margin: 0 auto 20px;
    padding-top: 20px;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/allocationDetails/allocationDetails.vue